import { render, staticRenderFns } from "./page-view-financial-report.vue?vue&type=template&id=67a8c8fc&scoped=true"
import script from "./page-view-financial-report.vue?vue&type=script&lang=js"
export * from "./page-view-financial-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a8c8fc",
  null
  
)

export default component.exports